import React from 'react';
import _ from 'lodash';
import SmallDonutChartDetail, {
  ISpaceChartData,
} from 'spw-components/charts/small-donut-chart-detail';
import { TITLES } from 'spw-constants';
import { ISpaceTypesUSF } from 'spw-programming-projects/program-summary/program-summary-tabs/program-scenario-summary';
import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import { IProjectSettings } from 'spw-redux/modules/settings/types';
import { useSelector } from 'react-redux';
import { projectColors as selectProjectColors } from 'spw-redux/modules/projects/selectors';
import useUnitConversion from 'spw-components/unit-conversion/hooks';

interface ISpaceTypeAllocationUsfDetailChart {
  spaceTypesUsf: ISpaceTypesUSF;
  style?: { [key: string]: number | string };
  showNamesInTable?: boolean;
  projectSettings: IProjectSettings;
  spaceTypeCategories: IProjectSpaceTypeCategory[];
}

const SpaceTypeAllocationUsfDetailChart: React.FunctionComponent<ISpaceTypeAllocationUsfDetailChart> = ({
  spaceTypesUsf,
  style,
  showNamesInTable,
  spaceTypeCategories,
}) => {
  const { getUnit, convertArea } = useUnitConversion();
  const programSubtotalUsf = _.sum(_.values(spaceTypesUsf));
  const projectColors = useSelector(selectProjectColors);

  const data = [
    ['Space Type', 'Count'],
    [TITLES.INDIVIDUAL_WORK_SPACES, spaceTypesUsf.individualWorkspaces],
    [TITLES.MEETING_SPACES, spaceTypesUsf.meetingSpaces],
    [TITLES.AMENITY_SPACES, spaceTypesUsf.amenitySpaces],
    [TITLES.SUPPORT_SPACES, spaceTypesUsf.supportSpaces],
  ];

  const spaceTypesData: ISpaceChartData[] = spaceTypeCategories.map(
    (projectSpaceTypeCategory: IProjectSpaceTypeCategory) => {
      const { category } = projectSpaceTypeCategory.defaultSpaceTypeCategory;
      const spaceTypeUsf = spaceTypesUsf[category as keyof ISpaceTypesUSF];
      const color = projectColors[category];
      return {
        quantity: convertArea(spaceTypeUsf),
        percent: spaceTypeUsf / programSubtotalUsf,
        name: projectSpaceTypeCategory.name,
        category,
        color: color as string,
      };
    }
  );

  return (
    <div
      data-testid="space_type_allocation_usf_detail_chart"
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <SmallDonutChartDetail
        style={style || { height: 232 }}
        title="Space Type Allocation"
        subtitle={`Subtotal ${getUnit('area')}`}
        total={convertArea(programSubtotalUsf)}
        spacesData={spaceTypesData}
        data={data}
        colors={spaceTypesData.map((spaceData) => spaceData.color as string)}
        showNamesInTable={showNamesInTable}
        showStackedNames
        testingPrefix=""
      />
    </div>
  );
};

export default SpaceTypeAllocationUsfDetailChart;
